import './App.css';
import './Font.css';
import React, { useEffect, useState } from 'react';
import Routes from './Routes';
import { LoadingSpinner } from './Components/Molecules/LoadingUI';
import { Link, NavLink } from 'react-router-dom';
import Modal from './Components/Organisms/Modal';
import { useLocation } from 'react-router-dom';
import Footer2 from './Components/Organisms/Footer2';
import Footer1 from './Components/Organisms/Footer1';
import { useMediaQuery, useTheme } from '@mui/material';

import { scrollToTargetAdjusted } from './utils/ui';
import { isBrigade, isCkpc, isMahindra, updateCartCount } from './helpers';

import { useAppInit } from './Hooks';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import LoginModal from './Components/LoginModal';
import FooterNavBar from './Components/Organisms/FooterNavBar';
import { authActions } from './store/auth-slice';
import { dealAction } from './store/deal-slice';
import store from './store';

import NavBar from './Components/Organisms/NavBar';
import CustomFooter from './Components/godrej/Footer';
import WebviewMenu, { WebviewModal } from './Components/Molecules/WebviewMenu';
import { CartModal } from '@reloy/shared-components';
import { winnreAuth, winnreNoAuth } from './utils/axios';
import DropDownNavBar from './Components/Organisms/DropDownNavBar';
import { isAloha } from './helpers';

function App() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const webViewAccessToken = queryParams.get('token');
    const clientToken = queryParams.get('clientToken');
    const [openWebviewMenu, setOpenWebviewMenu] = useState(false);
    const dispatch = useDispatch();
    const theme = useTheme();
    const screenBelowLg = useMediaQuery(theme.breakpoints.down('lg'));
    const openLoginModal = () => {
        dispatch(authActions.openLoginModal());
    };
    const [openCartModal, setOpenCartModal] = useState(false);
    const [isCartVisible, setIsCartVisible] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [cartValue, setCartValue] = useState([]);
    const [isCartUpdate, setIsCartUpdate] = useState(false);

    const hideNavAndFooter = false;
    const {
        loading,
        config,
        loadingWebviewToken,
        tokenLoading,
        clientWebview,
        userWebview,
        internalWebview,
        hiddenOnWebview,
        preLoginWebview,
        clientAndUserTokenLoading,
        refreshOnNoActivity
    } = useAppInit();
    const {
        unauthorizedUser,
        unauthorizedUserMessage,
        userRole,
        isAuthenticated,
        onboardingModalVisible,
        profileCompletionPercentage,
        finishedFirstTimeLoginGuide,
        isLoginModalVisible,
        showSessionTimeout
    } = useSelector((state) => state.auth);
    const dealState = useSelector((state) => state.deals || {});
    const authState = useSelector((state) => state.auth || {});
    const isCartModalVisible = useSelector(
        (state) => state.deals?.isCartModalVisible
    );

    const redux = {
        store,
        auth: authState,
        dispatch,
        authActions,
        dealAction,
        deal: dealState,
        deals: dealState
    };
    let scrollTo = location?.state?.scrollTo;

    useEffect(() => {
        if (scrollTo) {
            scrollToTargetAdjusted(scrollTo);
        }
    }, [scrollTo]);

    useEffect(() => {
        updateCartCount(setCartCount, setCartValue);

        const handleCartUpdated = () => {
            setIsCartUpdate(true);
            updateCartCount(setCartCount, setCartValue);
        };

        window.addEventListener('cartUpdated', handleCartUpdated);

        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdated);
        };
    }, []);

    useEffect(() => {
        const pathname = location?.pathname?.toLowerCase() || '';
        const isRewardStore =
            pathname.includes('rewardpointstore') ||
            pathname.includes('reward-deallisting') ||
            pathname.includes('/rewards') ||
            pathname.includes('dealsanddiscounts');
        setIsCartVisible(isRewardStore);
    }, [location.pathname]);

    useEffect(() => {
        if (isCartModalVisible && isCartVisible && cartCount > 0) {
            setOpenCartModal(true);
            return;
        }
        if (!isCartModalVisible) {
            setOpenCartModal(false);
        }
    }, [isCartModalVisible, isCartVisible, cartCount]);

    useEffect(() => {
        if (cartCount === 0) {
            setOpenCartModal(false);
        } else if (
            !screenBelowLg &&
            isCartUpdate &&
            location.pathname !== '/checkout'
        ) {
            setIsCartUpdate(false);
            if (isCartVisible) setOpenCartModal(true);
        }
    }, [
        isCartUpdate,
        screenBelowLg,
        cartCount,
        isCartVisible,
        location.pathname
    ]);

    useEffect(() => {
        console.log(
            isAuthenticated,
            window.reloy_env?.client_config?.LOGIN?.Enable_Login_Modal,
            config
        );
        if (
            !isAuthenticated &&
            !loading &&
            !tokenLoading &&
            window.reloy_env?.client_config?.LOGIN?.Enable_Login_Modal
        ) {
            openLoginModal();
        }
    }, [isAuthenticated, tokenLoading, loading]);

    console.log({ screenBelowLg, isAloha: isAloha() });

    return (
        <>
            {showSessionTimeout && (
                <Modal visible>
                    <div className="flex flex-col justify-center items-center">
                        <div className="text-center text-lg py-2 mb-3">
                            {
                                'Hey, are you still there?\nYour Session is about to expire!'
                            }
                        </div>
                        <Button
                            onClickFunc={() => refreshOnNoActivity()}
                            content="Click Here to Continue"
                            onClick="FUNC"
                        ></Button>
                    </div>
                </Modal>
            )}
            {(loading ||
                tokenLoading ||
                loadingWebviewToken ||
                clientAndUserTokenLoading) && (
                    <div className="h-[100vh]">
                        <LoadingSpinner
                            text={
                                'Hold on while we elevate your homeowning experience…'
                            }
                            color="text-info"
                            size={16}
                        />
                    </div>
                )}

            {!loading &&
                !tokenLoading &&
                !unauthorizedUser &&
                !loadingWebviewToken &&
                !clientAndUserTokenLoading && (
                    <div className="App relative">
                        {/* NavBar */}
                        {/* NavBar */}
                        {!hiddenOnWebview &&
                            !hideNavAndFooter &&
                            (isAloha() || isBrigade() || isCkpc() ? (
                                <DropDownNavBar cartCount={cartCount} />
                            ) : (
                                <NavBar cartCount={cartCount} />
                            ))}

                        {/* Main */}
                        <Routes routesConfig={config} />
                        <ToastContainer position="top-right" />

                        {/* Footer */}
                        {/* Footer */}
                        {/* Footer */}
                        {config?.showFooterRoutes &&
                            !hiddenOnWebview &&
                            !hideNavAndFooter && (
                                <FooterNavBar config={config.footerRoutes} />
                            )}
                        {!hiddenOnWebview &&
                            !config?.customHomePage &&
                            !hideNavAndFooter &&
                            (config.footer?.layout === 'Layout1' ? (
                                <Footer1 />
                            ) : (
                                <Footer2 />
                            ))}
                        {config?.customHomePage && (
                            <CustomFooter config={config} />
                        )}
                    </div>
                )}
            {/* {clientWebview && !unauthorizedUser && (
                <div
                    onClick={() => setOpenWebviewMenu((prev) => !prev)}
                    className="fixed flex items-center right-0 top-2 h-12 w-12 z-40  mx-auto"
                >
                    <FiMenu className="text-black h-full text-center w-full p-1" />
                </div>
            )} */}
            {isLoginModalVisible && !internalWebview && !preLoginWebview && (
                <LoginModal />
            )}
            {openWebviewMenu && clientWebview && !unauthorizedUser && (
                <WebviewModal
                    visible={openWebviewMenu}
                    onClick={() => {
                        setOpenWebviewMenu(false);
                    }}
                >
                    <WebviewMenu
                        onClick={() => {
                            setOpenWebviewMenu(false);
                        }}
                    />
                </WebviewModal>
            )}
            {openCartModal && isCartVisible && (
                <CartModal
                    openCartModal={openCartModal}
                    setOpenCartModal={setOpenCartModal}
                    cartValue={cartValue}
                    cartCount={cartCount}
                    setCartCount={setCartCount}
                    setCartValue={setCartValue}
                    screenBelowLg={screenBelowLg}
                    redux={redux}
                    winnreAuth={winnreAuth}
                    appType="winnre"
                    isPoints
                ></CartModal>
            )}
        </>
    );
}

export default App;
